import { render, staticRenderFns } from "./GetTodo.vue?vue&type=template&id=c052bea6&"
import script from "./GetTodo.vue?vue&type=script&lang=js&"
export * from "./GetTodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports